export { UIGamePlayerInformationProgress } from './UIGamePlayerInformationProgress.tsx';
